import React, { useState } from 'react'
import { useGetPurchaseOrdersQuery } from 'services/purchaseOrders'
import ContractsContainer from 'components/containers/contracts/ContractsContainer'
import useGlobalLoader from 'utils/custom-hooks/useGlobalLoader'

const PurchaseOrdersContainer = () => {
  const [isArchiving, setIsArchiving] = useState(false)
  const { data, isFetching } = useGetPurchaseOrdersQuery({}, { skip: isArchiving })

  useGlobalLoader(false)

  return <ContractsContainer data={data} isLoading={isFetching} setIsArchiving={setIsArchiving} />
}

export default PurchaseOrdersContainer
